import React from "react";
import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { formatCurrency } from "utils/currency";
import {
  poItemOrderedQty,
  poItemRate,
  poItemLineTotal,
} from "../utils/purchase-order.utils";
import { usePurchaseOrderOverview } from "./PurchaseOrderOverviewContext";

const ItemsAndReceiptsTab = () => {
  const { purchaseOrder: record } = usePurchaseOrderOverview();
  if (!record) return null;

  const items = record.items ?? [];
  const subTotal = items.reduce((sum, ln) => sum + poItemLineTotal(ln), 0);

  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Line items</h5>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <Table className="table-nowrap align-middle mb-0">
                <thead className="table-light text-muted">
                  <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Supplier</th>
                    <th scope="col" className="text-end">
                      Ordered
                    </th>
                    <th scope="col">Unit</th>
                    <th scope="col" className="text-end">
                      Rate
                    </th>
                    <th scope="col" className="text-end">
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.length ? (
                    items.map((ln, i) => {
                      return (
                        <tr key={ln.id ?? i}>
                          <td className="fw-medium">
                            {ln.description?.trim() || "—"}
                          </td>
                          <td className="text-muted small">
                            {ln.supplier
                              ? [ln.supplier.code, ln.supplier.name]
                                  .filter(Boolean)
                                  .join(" · ")
                              : "—"}
                          </td>
                          <td className="text-end tabular-nums">
                            {poItemOrderedQty(ln)}
                          </td>
                          <td className="text-muted">{ln.unit || "—"}</td>
                          <td className="text-end">
                            {formatCurrency(poItemRate(ln))}
                          </td>
                          <td className="text-end">
                            {formatCurrency(poItemLineTotal(ln))}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-muted py-4 text-center">
                        No line items on this purchase order.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {items.length ? (
              <div className="table-responsive table-card mt-4">
                <Table className="table-borderless align-middle mb-0">
                  <tbody>
                    <tr className="table-active">
                      <th scope="row">Total</th>
                      <td className="text-end">
                        <span className="fw-semibold fs-15">
                          {formatCurrency(subTotal)}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ItemsAndReceiptsTab;
